import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { testCategoriesData } from "@/templates/confluence-templates-page/src/test-data/test-data";

import type { TemplatePageMetadata } from "./utils/confluence-templates-queries/get-template-metadata";

interface ILoaderMatcher {
    match: RegExp;
    name: string;
    getPageMetadata?: (props: {
        templates?: Template[];
        collections?: TemplateCollection[];
        urlSlug?: string;
    }) => TemplatePageMetadata | undefined;
}

export const LoaderMatchers: ILoaderMatcher[] = [
    {
        match: /templates$/,
        name: "confluence-templates-page"
    },
    {
        match: /templates\/search$/,
        name: "confluence-template-search-page"
    },
    {
        match: /templates\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-details-page",
        getPageMetadata: ({ templates, urlSlug }) => {
            const template = templates?.find(
                (template) => template.urlSlug === urlSlug
            );

            return template
                ? {
                      title: template?.name,
                      description: template?.oneLinerHeadline,
                      titleSuffix: "template"
                  }
                : undefined;
        }
    },
    {
        match: /templates\/collections\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-collection-details-page",
        getPageMetadata: ({ collections, urlSlug }) => {
            const collection = collections?.find(
                (collection) => collection.urlSlug === urlSlug
            );

            return collection
                ? {
                      title: collection?.name,
                      description: collection?.oneLinerHeadline,
                      titleSuffix: "collection"
                  }
                : undefined;
        }
    },
    {
        match: /templates\/categories\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-category-page",
        getPageMetadata: ({ urlSlug }) => {
            // use testCategoriesData for now
            const category = testCategoriesData.find(
                (category) => category.urlSlug === urlSlug
            );
            return category
                ? {
                      title: category?.pageTitle,
                      description: category?.shortDescriptionOneLiner
                  }
                : undefined;
        }
    }
];
